"use client";

import { Nav } from "@yardzen/ui/components/nav";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function CheckoutNav() {
  const router = useRouter();
  const [packageName, setPackageName] = useState<string | null>(null);

  useEffect(() => {
    // Get package from URL parameters on client side
    const urlParams = new URLSearchParams(window.location.search);
    const packageParam = urlParams.get("package");
    setPackageName(packageParam);
  }, []);

  function handleGoBack() {
    if (packageName) {
      router.push(`/${packageName}`);
    } else {
      router.push("/");
    }
  }

  return <Nav variant="floating" onGoBack={handleGoBack} />;
}
